import angular from 'angular';

export default angular.module('cms.save.warning.dialog', [])
    .factory('saveWarningDialog', ($uibModal) => {

        let service = {};

        service.open = () => {
            let modalInstance = $uibModal.open({
                animation: true,
                template: require('./saveWarningDialog.html'),
                size: 'md',
                keyboard: false,
                backdrop: 'static'
            });

            return modalInstance.result;
        };


        return service;


    }).name


// WEBPACK FOOTER //
// ./src/cmsCore/SaveWarning/saveWarningDialog.js